// extracted by mini-css-extract-plugin
module.exports =  {"badge__button":"BadgeButton-module__badge__button___g1I8O"};